import { QueryKey } from "@tanstack/react-query";

export const onboardingSettingsAsMember = {
  all: () => ["onboardingSettingsAsMember"] as QueryKey,
};
